"use client";

import { useEffect } from "react";

export default function SentryProvider() {
  useEffect(() => {
    import("@/instrumentation-client");
  }, []);

  return null;
}
